import React, { useEffect } from 'react';
import useTranslation from '../../hooks/useTranslation';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { create } from './table-schema';
import timeFormAPI from '../../api/ui/timeFormAPI';
import { getMediaType, mediaType } from '../../utils/enum';

function useSchemaFileUpload(onImageClick) {
  const { t } = useTranslation();
  const locale = useSelector((state) => state.language.locale);

  const absolutePath = `https://perplayblobdev.blob.core.windows.net`;
  /**
   * 테이블 헤더에 표시할 항목 문자열 배열
   */
  const headerKeys = [
    '파일 경로',
    '등록된 미디어 파일 미리보기',
    '업로드 일시',
  ];

  /**
   *
   * @param {String} path
   */
  const getFileType = (path) => {
    const ext = path.split('.').at(-1);
    return getMediaType(ext);
  };

  const getPreview = (path, createdAt) => {
    if (!path) {
      return <></>;
    }

    const type = getFileType(path);
    if (type === mediaType.image) {
      return (
        <>
          <img
            className="tableMedia"
            alt=""
            src={path + '?' + createdAt}
            onClick={() => onImageClick(path + '?' + createdAt)}
            style={{ cursor: 'pointer', minWidth: "auto" }}
          />
        </>
      );
    }
    if (type === mediaType.video) {
      return <video className="tableMedia" src={path} autoPlay loop muted />;
    }
    return <></>;
  };

  const getLink = (path, createdAt) => {
    if (path) {
      return (
        <a
          href={`${path + '?' + createdAt}`}
          target="_blank"
          rel="noreferrer"
          style={{ whiteSpace: 'nowrap' }}
        >
          {`${path}`}
        </a>
      );
    }
    return <></>;
  };

  /**
   * 서버로부터 전달받은 request를 테이블에 표시할 내용으로 변환한다.
   *
   * 오브젝트 키는 param1, param10 등의 형식으로 param 다음에 숫자를 붙여서 사용한다.
   *
   * param1은 헤더의 첫번째 표시되는 항목이다.
   *
   * key는 반드시 있어야 한다.
   * @param {object} row
   * @returns
   */
  let no = 0;
  const parse = (row) => {
    // 응답 예시: https://perplayblobdev.blob.core.windows.net/perplay-hub/EventBoard/123_20241112061922422_KO.png?11/12/2024 06:19:22
    // 파일명에 ? 포함되는 경우 있음
    // 마지막 ?를 기준으로 파일 경로와 업로드 일시를 구분한다.
    const questionMarkIndex = row.lastIndexOf('?');
    const path = row.slice(0, questionMarkIndex);
    const createdAt = row.slice(questionMarkIndex + 1);

    // 캐싱 때문에 업로드 일시를 붙여서 보내야함
    const preview = getPreview(path, timeFormAPI.changeDataLog(createdAt));
    const link = getLink(path, timeFormAPI.changeDataLog(createdAt));

    // 키가 같으면 표시 되지 않거나 다른 폴더에 있는 파일 보여지는 현상 있음
    return {
      key: path + no++, // 키는 반드시 있어야 한다.
      param1: link,
      param2: preview,
      param3: timeFormAPI.changeDataLog(createdAt),
    };
  };

  /**
   * 로그 데이터를 클릭했을 때 보여줄 디테일 다이얼로그에 보여줄 항목을 작성한다.
   *
   * 입력값인 row는 위의 parse에서 변환된 값이다.
   *
   * @param {object} row
   * @returns
   */
  const details = (row) => {
    const array = [];
    if (row) {
      //
    }
    return array;
  };

  const [schema, setSchema] = useState();

  useEffect(() => {
    const headers = headerKeys.map((key) => t(key));
    const schema = create({
      heads: headers,
      parseFunc: parse,
      detailFunc: details,
    });
    setSchema(schema);
  }, [locale]);

  return { schema: schema };
}

export default useSchemaFileUpload;
